export default __webpack_public_path__ + "static/media/carousel3.2444c3c4.png";